module.exports = __webpack_public_path__ + "img/photo7.6ac9ec69.jpg";